import { StyleSheet } from 'aphrodite';
import constants from '../../../constants/styles';
let { TABLE_BG_COLOR, TABLE_HEADER_TEXT_COLOR } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: TABLE_BG_COLOR,
    color: TABLE_HEADER_TEXT_COLOR,
    maxHeight: '100%',
    overflowY: 'hidden',
    overflowX: 'hidden'
  },
  body: {
    overflowY: 'auto',
    height: '100%',
    minWidth: 920
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    flexShrink: 0,
    height: 33,
    minWidth: 920,
    width: '100%'
  },
  headerMargin: {
    marginRight: 17
  },
  select: {
    width: 30,
    minWidth: 30,
    textAlign: 'center',
    paddingLeft: 6,
    flexShrink: 0
  },
  headerCell: {
    textTransform: 'uppercase',
    textAlign: 'left',
    fontSize: '0.75em',
    fontWeight: 'bold',
    verticalAlign: 'middle',
    ':nth-child(1n) ul': {
      textTransform: 'none',
      width: 140,
      left: '-32px',
      ':before': {
        left: 63
      }
    }
  },
  search: {
    textAlign: 'right',
    paddingRight: 20,
    width: 80,
    flexShrink: 0
  },
  searchBase: {
    height: '100%',
    width: 'auto'
  },
  searchHeader: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: '0 4px'
  },
  searchInput: {
    width: '30vw',
    minWidth:'400px',
    marginTop: 2,
    height: 29,
    fontSize: '0.8em'
  },
  searchInputIcon: {
    top: -22
  },
  searchIcon: {
    cursor: 'pointer'
  },
  closeSearch: {
    fontSize: 20,
    cursor: 'pointer',
    marginTop: 5,
    marginLeft: 10
  },
  toolBar: {
    display: 'flex',
    flexFlow: 'row',
    width: '100%',
    justifyContent: 'left'
  },
  button: {
    fontSize: '0.9em',
    maxHeight: 33,
    boxSizing: 'border-box',
    fontWeight: 400,
    textTransform: 'none',
    padding: '5px 6px',
    margin: '2px'
  },
  count: {
    height: '100%',
    alignSelf: 'center',
    color: 'white',
    marginRight: 'auto'
  },
  icon: {
    fontWeight: 'bold',
    fontSize: '13px',
    marginRight: '4px'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/datatable/DataTable.styles.js